



















































import Vue from 'vue';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { api, VAULT_API_SUB_URLS } from '@/api';
import { ExtendMixins } from '@/services';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  refreshError: boolean;
  scrollUpOnClose: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'RemoveDocument',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      refreshError: false,
      scrollUpOnClose: false,
    };
  },
  computed: {
    contentCallout(): string {
      return this.params.document.fileNickname
        ? this.params.document.fileNickname
        : this.params.document.fileName;
    },
  },
  methods: {
    removeDocument(): void {
      this.isLoading = true;
      // Call REST-078 Delete Vault Data
      api
        .delete(`${VAULT_API_SUB_URLS.vaultData}/${this.params.document.vaultId}`)
        .then(() => {
          this.refreshEvaultData();
        })
        .catch(() => {
          this.isLoading = false;
          this.showErrorMessage = true;
        });
    },
    closeRemoveDocumentScreen(): void {
      this.closeFullscreenWrapper();

      if (this.scrollUpOnClose) {
        setTimeout(() => {
          this.$vuetify.goTo(0);
        }, 350);
      }
    },
    refreshEvaultData(): void {
      this.$store
        .dispatch('getVaultData')
        .then((newEvaultData) => {
          if (!newEvaultData.length) {
            this.scrollUpOnClose = true;
          }
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'remove-document_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
